export default defineNuxtPlugin(() => {
});
